(ns common.schema.entities.counterparty-diligence.process
  (:require [common.schema.schema-utils :as su]))

(def status-options
  (->>
   [{:value :counterparty-diligence-process.status/draft
     :label "Draft"}
    {:value :counterparty-diligence-process.status/sent-to-responders
     :label "Sent to responders"}
    {:value :counterparty-diligence-process.status/waiting-for-e-sign
     :label "E-Signature"}
    {:value :counterparty-diligence-process.status/review
     :label "Review"}
    {:value :counterparty-diligence-process.status/completed
     :label "Completed"}]
   (mapv (fn [{:keys [value] :as opt}]
           (assoc opt :key value)))))

(def status-options-by-value
  (->> status-options
       (mapv (fn [{:keys [value] :as opt}]
               [value opt]))
       (into {})))

(defn get-status-label
  [value]
  (get-in status-options-by-value [value :label]))

(def schema
  (concat
   (su/keyword-field :counterparty-diligence-process/status
                     "Status"
                     status-options
                     {:authorization            su/access-system-user
                      :default-field-visibility :in-use-disabled})

   (su/text-edn-field :counterparty-diligence-process/answers
                      "Answers"
                      {:authorization            su/access-cdg-cdg
                       :default-field-visibility :in-use-disabled})

   (su/text-simple-field :counterparty-diligence-process/invite-token
                         "Invite token"
                         {:authorization            su/access-system-user
                          :default-field-visibility :in-use-disabled})

   (su/text-edn-field :counterparty-diligence-process/responders
                      "Responders"
                      {:authorization            su/access-system-user
                       :default-field-visibility :in-use-disabled})

   (su/keyword-field :counterparty-diligence-process/template-kw
                     "Template (keyword)"
                     []
                     {:authorization            su/access-system-user
                      :default-field-visibility :in-use-disabled})))
